import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "acordeon-container" }
const _hoisted_2 = ["aria-expanded", "aria-controls", "id"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["id", "aria-labelledby"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "acordeon-header",
      "aria-expanded": _ctx.isOpen,
      "aria-controls": _ctx.contentId,
      id: _ctx.buttonId,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["arrow-down", { open: _ctx.isOpen }])
      }, null, 2)
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      id: _ctx.contentId,
      class: "acordeon-content",
      role: "region",
      "aria-labelledby": _ctx.buttonId,
      style: _normalizeStyle({ display: _ctx.isOpen ? 'block' : 'none' })
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 12, _hoisted_4)
  ]))
}